export * from './App'
import App from './App'

export default App
